var map = {
	"./pay_ali_active.png": "BbDR",
	"./pay_union_active.png": "xUQ7",
	"./pay_wx_active.png": "IIK1"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "iuHs";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/pay ^\.\/.*_active\.png$
// module id = iuHs
// module chunks = 1